import React from 'react';
import { Box, Button, FormHelperText, Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { UnlayerEditorWrapper } from '@/components/UnlayerEditorWrapper';
import { UNLAYER_EDITOR_MIN_HEIGHT } from '@/components/Drawers/AddUnlayerEmailDrawer/constants';
import { useUnlayerUIContext } from '@/context/UnlayerUIContext';
import { useUnlayerComposeInteractionsContext } from '@/context/UnlayerComposeInteractionsContext';
import { useUnlayerMergeTagsContext } from '@/context/UnlayerMergeTagsContext';
import { useUnlayerSignatureContext } from '@/context/UnlayerSignatureContext';

/**
 * Renders the Unlayer editor and the auxiliary controls that manage editor-only actions.
 */
export const EditorSection = () => {
	const { designToLoad, markProgrammaticDesignLoaded, openLoadDesignDialog } =
		useUnlayerUIContext();
	const { handleEditorChange } = useUnlayerComposeInteractionsContext();
	const { mergeTags } = useUnlayerMergeTagsContext();
	const { signatureInsertRequest } = useUnlayerSignatureContext();
	const { errors, isSubmitting, touched } = useFormikContext();

	return (
		<>
			<Stack direction='row' justifyContent='flex-end' sx={{ mt: 1 }}>
				<Button variant='outlined' disabled={isSubmitting} onClick={openLoadDesignDialog}>
					Load Design JSON
				</Button>
			</Stack>

			<Box
				sx={{
					minHeight: UNLAYER_EDITOR_MIN_HEIGHT,
					flexShrink: 0,
				}}
			>
				<UnlayerEditorWrapper
					minHeight={UNLAYER_EDITOR_MIN_HEIGHT}
					initialDesign={null}
					designToLoad={designToLoad}
					mergeTags={mergeTags}
					onProgrammaticDesignLoad={markProgrammaticDesignLoaded}
					signatureInsertRequest={signatureInsertRequest}
					onChange={handleEditorChange}
				/>
				{touched.editorHtml && errors.editorHtml && (
					<FormHelperText error>{errors.editorHtml}</FormHelperText>
				)}
			</Box>
		</>
	);
};
